import { Injectable } from '@angular/core';
import Vacancy from '../model/Vacancy';
import AbstractRestService from './abstract-rest-service.interface';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class VacancyStore extends AbstractRestService<Vacancy> {
  constructor(http: HttpClient, env: EnvironmentService) {
    super(http, env.vacanciesFetchUrl);
  }
}
